module.exports = __webpack_public_path__ + "img/zhang.d5c6fcc4.png";